module.exports = __webpack_public_path__ + "static/media/booki_desktop.3c108d66.webp";